"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterLocation = void 0;
/** the location that this parameter is placed in the http request */
var ParameterLocation;
(function (ParameterLocation) {
    /**  Parameters that are appended to the URL. For example, in /items?id=###, the query parameter is id */
    ParameterLocation["Query"] = "query";
    /**  Custom headers that are expected as part of the request. Note that RFC7230 states header names are case insensitive. */
    ParameterLocation["Header"] = "header";
    /** Used to pass a specific cookie value to the API. */
    ParameterLocation["Cookie"] = "cookie";
    /**  Used together with Path Templating, where the parameter value is actually part of the operation's URL. This does not include the host or base path of the API. For example, in /items/{itemId}, the path parameter is itemId. */
    ParameterLocation["Path"] = "path";
    /** Used to encode the parameter and send it as the HTTP body  */
    ParameterLocation["Body"] = "body";
    /** Used to associate the parameter to the Server/Uri (ie, parameterized host ) */
    ParameterLocation["Uri"] = "uri";
    /** Virtual parameters represent a connection to a specific spot in the body */
    ParameterLocation["Virtual"] = "virtual";
    /** Not directly used in a request, but may be used indirectly. */
    ParameterLocation["None"] = "none";
})(ParameterLocation || (exports.ParameterLocation = ParameterLocation = {}));
//# sourceMappingURL=parameter-location.js.map